module.exports = __webpack_public_path__ + "static/img/tmptype5.18438afe.png";